module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-1.3358a4dc.png";